import { map, uniq, delay, lowerCase, reduce, trim, compact } from 'lodash';
import { seq } from 'async';

import callApi from '../../util/apiCaller';

// Export Constants
export const DASHBOARD_RESET_ALL = 'DASHBOARD_RESET_ALL';
export const DASHBOARD_FETCH_CURRENT_GLOBAL_RANKINGS = 'DASHBOARD_FETCH_CURRENT_GLOBAL_RANKINGS';
export const DASHBOARD_FETCH_PIPELINE_OPPORTUNITIES = 'DASHBOARD_FETCH_PIPELINE_OPPORTUNITIES';
export const DASHBOARD_FETCH_FORECAST_OPPORTUNITIES = 'DASHBOARD_FETCH_FORECAST_OPPORTUNITIES';
export const DASHBOARD_FETCH_CONVERSION_OPPORTUNITIES = 'DASHBOARD_FETCH_CONVERSION_OPPORTUNITIES';
export const DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES = 'DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES';
export const DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_FEEDBACKS = 'DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_FEEDBACKS';
export const DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_FEEDBACK = 'DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_FEEDBACK';
export const DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_REQUESTED_FEEDBACK = 'DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_REQUESTED_FEEDBACK';

export const DASHBOARD_REQUEST_EDIT_WIN_LOSS_OPPORTUNITY_FEEDBACKS = 'DASHBOARD_REQUEST_EDIT_WIN_LOSS_OPPORTUNITY_FEEDBACKS';
export const DASHBOARD_REQUEST_EDIT_WIN_LOSS_ACCOUNT_FEEDBACKS = 'DASHBOARD_REQUEST_EDIT_WIN_LOSS_ACCOUNT_FEEDBACKS';

export const DASHBOARD_REQUEST_LOAD_WIN_LOSS_OPPORTUNITY_CONTACTS = 'DASHBOARD_REQUEST_LOAD_WIN_LOSS_OPPORTUNITY_CONTACTS';
export const DASHBOARD_REQUEST_LOAD_WIN_LOSS_ACCOUNT_CONTACTS = 'DASHBOARD_REQUEST_LOAD_WIN_LOSS_ACCOUNT_CONTACTS';

export const DASHBOARD_REQUEST_LOAD_OPPORTUNITY_INSIGHTS = 'DASHBOARD_REQUEST_LOAD_OPPORTUNITY_INSIGHTS';
export const DASHBOARD_REQUEST_LOAD_ACCOUNT_INSIGHTS = 'DASHBOARD_REQUEST_LOAD_ACCOUNT_INSIGHTS';

export const DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_SURVEYS = 'DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_SURVEYS';

export const DASHBOARD_REQUEST_SHOW_WIN_LOSS_SURVEY_EMAIL = 'DASHBOARD_REQUEST_SHOW_WIN_LOSS_SURVEY_EMAIL';
export const DASHBOARD_REQUEST_CANCEL_WIN_LOSS_SURVEY = 'DASHBOARD_REQUEST_CANCEL_WIN_LOSS_SURVEY';
export const DASHBOARD_REQUEST_DELETE_WIN_LOSS_SURVEY = 'DASHBOARD_REQUEST_DELETE_WIN_LOSS_SURVEY';
export const DASHBOARD_REQUEST_WIN_LOSS_SEND_NEXT_EMAIL = 'DASHBOARD_REQUEST_WIN_LOSS_SEND_NEXT_EMAIL';


export const DASHBOARD_FETCH_WIN_LOSS_GLOBAL_RANKINGS = 'DASHBOARD_FETCH_WIN_LOSS_GLOBAL_RANKINGS';
export const DASHBOARD_FETCH_COLLECTOR_SUMMARY = 'DASHBOARD_FETCH_COLLECTOR_SUMMARY';

export const DASHBOARD_REQUEST_TOGGLE_PAUSE_WIN_LOSS_SURVEY = 'DASHBOARD_REQUEST_TOGGLE_PAUSE_WIN_LOSS_SURVEY';
export const DASHBOARD_REQUEST_RESCHEDULE_WIN_LOSS_SURVEY = 'DASHBOARD_REQUEST_RESCHEDULE_WIN_LOSS_SURVEY';

export const DASHBOARD_WIN_LOSS_EXCLUDE_OPPORTUNITY = 'DASHBOARD_WIN_LOSS_EXCLUDE_OPPORTUNITY';
export const DASHBOARD_WIN_LOSS_INCLUDE_OPPORTUNITY = 'DASHBOARD_WIN_LOSS_INCLUDE_OPPORTUNITY';

export const DASHBOARD_FETCH_WIN_LOSS_ACCOUNT_RESULTS = 'DASHBOARD_FETCH_WIN_LOSS_ACCOUNT_RESULTS';
export const DASHBOARD_FETCH_WIN_LOSS_ACCOUNT_JOBS = 'DASHBOARD_FETCH_WIN_LOSS_ACCOUNT_JOBS';
export const DASHBOARD_ADD_WIN_LOSS_ACCOUNT_JOB = 'DASHBOARD_ADD_WIN_LOSS_ACCOUNT_JOB';
export const DASHBOARD_DELETE_WIN_LOSS_ACCOUNT_JOB = 'DASHBOARD_DELETE_WIN_LOSS_ACCOUNT_JOB';
export const DASHBOARD_UPDATE_WIN_LOSS_ACCOUNT_STATUS = 'DASHBOARD_UPDATE_WIN_LOSS_ACCOUNT_STATUS';
export const DASHBOARD_REQUEST_CHANGE_CONTACT_SENDER = 'DASHBOARD_REQUEST_CHANGE_CONTACT_SENDER';
export const DASHBOARD_FEEDBACK_REQUEST_SETTINGS = 'DASHBOARD_FEEDBACK_REQUEST_SETTINGS';
export const DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_SELLER_FEEDBACKS = 'DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_SELLER_FEEDBACKS';
export const DASHBOARD_FETCH_OPPORTUNITY_FEEDBACK_REQUEST_STATUS = 'DASHBOARD_FETCH_OPPORTUNITY_FEEDBACK_REQUEST_STATUS';

export const DASHBOARD_FETCH_COLLECTOR_STATS = 'DASHBOARD_FETCH_COLLECTOR_STATS';

export const DASHBOARD_WIN_LOSS_EXCLUDE_ACCOUNT = 'DASHBOARD_WIN_LOSS_EXCLUDE_ACCOUNT';
export const DASHBOARD_WIN_LOSS_INCLUDE_ACCOUNT = 'DASHBOARD_WIN_LOSS_INCLUDE_ACCOUNT';

export const DASHBOARD_FETCH_WIN_LOSS_INTERNAL_EMAILS = 'DASHBOARD_FETCH_WIN_LOSS_INTERNAL_EMAILS';

export const DASHBOARD_FETCH_EXCLUDED_OPPORTUNITIES = 'DASHBOARD_FETCH_EXCLUDED_OPPORTUNITIES';
export const DASHBOARD_FETCH_EXCLUDED_CONTACTS = 'DASHBOARD_FETCH_EXCLUDED_CONTACTS';
export const DASHBOARD_CHECK_QUALIFIED_CHUNK = 'DASHBOARD_CHECK_QUALIFIED_CHUNK';

export const DASHBOARD_REQUEST_CHANGE_ACCOUNT_SIZE = 'DASHBOARD_REQUEST_CHANGE_ACCOUNT_SIZE';

export const DASHBOARD_FETCH_PROGRESS_CONTACTS = 'DASHBOARD_FETCH_PROGRESS_CONTACTS';
export const DASHBOARD_APPEND_OPPORTUNITY_CONTACT_ROLE = 'DASHBOARD_APPEND_OPPORTUNITY_CONTACT_ROLE';

export function resetAll(resetTeams = false) {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_RESET_ALL, resetTeams,
    });
    return Promise.resolve();
  };
}


export function fetchPipelineOppotunities(criteria, industries) {
  return (dispatch) => {
    const empty = {
      status: null,
      errors: null,
      opportunities: [],
      owners: {},
      accounts: {},
      stages: {},
      totalStats: {},
      indexedOwnerStats: {},
      rankings: [],
      industries: {},
    };
    dispatch({
      type: DASHBOARD_FETCH_PIPELINE_OPPORTUNITIES, ...empty, status: 'loading', errors: null,
    });
    const included = [
      'owners',
      'products',
      'repTypes',
      'repRegions',
      'accounts',
      'logHistories',
      'stageHistories',
      'lineItems',
      'opportunityCompetitors',
    ];

    const { query, pipeline, team } = criteria;
    const params = {
      query,
      pipeline,
    };

    const teamId = team && team._id ? `&teamId=${team._id}` : '';
    delete params.team;
    const p = callApi(`dashboard/pipeline?include=${included.join(',')}${teamId}`, 'POST', params);

    p.then(
      ({
        opportunities, owners, stages, accounts,
      }) => dispatch({
        type: DASHBOARD_FETCH_PIPELINE_OPPORTUNITIES, opportunities, owners, stages, accounts, industries, status: 'loaded', errors: null,
      }),
      errors => dispatch({
        type: DASHBOARD_FETCH_PIPELINE_OPPORTUNITIES, ...empty, status: 'error', errors: errors.data || errors,
      }),
    );
    return p;
  };
}


export function fetchForecastOppotunities(params = {}) {
  const empty = {
    winRates: {}, ptdWins: {}, forecasts: [], untrackedOpportunities: [], start: null, end: null, sync_date: null, forecastId: null,
  };
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_FETCH_FORECAST_OPPORTUNITIES, ...empty, status: 'loading', errors: null,
    });
    const included = [
      'owners',
      'products',
      'repTypes',
      'repRegions',
      'accounts',
      'logHistories',
      'lineItems',
      'opportunityCompetitors',
    ];
    const { team } = params;
    const teamId = team && team._id ? `&teamId=${team._id}` : '';
    delete params.team;

    const p4 = callApi(`dashboard/forecast/?include=${included.join(',')}${teamId}`, 'POST', params);
    const p = new Promise((resolve, reject) => {
      Promise.all([p4]).then(
        ([res4]) => {
          resolve({
            isHistory: params.isHistory || false,
            winRates: res4.win_rates || {},
            ptdWins: res4.ptd_wins || {},
            forecasts: res4.forecasts,
            untrackedOpportunities: res4.untracked_opportunities || [],
            start: res4.start,
            end: res4.end,
            syncDate: res4.sync_date,
            forecastId: res4.forecast_id,
            owners: res4.owners,
            accounts: res4.accounts,
            status: 'loaded',
            errors: null,
          });
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    p.then(
      (results) => {
        dispatch({ type: DASHBOARD_FETCH_FORECAST_OPPORTUNITIES, ...empty, ...results });
      },
      (errors) => {
        dispatch({
          type: DASHBOARD_FETCH_FORECAST_OPPORTUNITIES, ...empty, status: 'error', errors,
        });
      },
    );
    return p;
  };
}

export function fetchConversionOpportunities(criteria) {
  return (dispatch) => {
    const empty = {
      status: null,
      errors: null,
      opportunities: [],
      owners: {},
    };
    dispatch({
      type: DASHBOARD_FETCH_CONVERSION_OPPORTUNITIES, ...empty, status: 'loading', errors: null,
    });
    const included = [
      'owners',
      'stageHistories',
      'logHistories',
      'accounts',
    ];
    const { team } = criteria;
    const teamId = team && team._id ? `&teamId=${team._id}` : '';
    delete criteria.team;
    const p = callApi(`dashboard/conversion?include=${included.join(',')}${teamId}`, 'POST', criteria);
    p.then(
      results => dispatch({
        type: DASHBOARD_FETCH_CONVERSION_OPPORTUNITIES, ...results, status: 'loaded', errors: null,
      }),
      errors => dispatch({
        type: DASHBOARD_FETCH_CONVERSION_OPPORTUNITIES, ...empty, status: 'error', errors: errors.data || errors,
      }),
    );
    return p;
  };
}

export function fetchCurrentGlobalRankings(criteria) {
  return (dispatch) => {
    const empty = {
      status: null,
      errors: null,
      owners: [],
    };
    dispatch({
      type: DASHBOARD_FETCH_CURRENT_GLOBAL_RANKINGS, ...empty, status: 'loading', errors: null,
    });
    const p = callApi('dashboard/rankings', 'POST', criteria);
    p.then(
      results => dispatch({
        type: DASHBOARD_FETCH_CURRENT_GLOBAL_RANKINGS, ...results, status: 'loaded', errors: null,
      }),
      errors => dispatch({
        type: DASHBOARD_FETCH_CURRENT_GLOBAL_RANKINGS, ...empty, status: 'error', errors: errors.data || errors,
      }),
    );
    return p;
  };
}

// fetch all feedbacks, summary only
export function fetchWinLossAllFeedbacks(dispatch, ids, accountBase = false) {
  if (ids && ids.length) {
    const uri = accountBase ? 'dashboard/win-loss/account-feedbacks' : 'dashboard/win-loss/opportunity-feedbacks';
    const p = callApi(uri, 'POST', { ids });
    p.then(
      (results) => {
        dispatch({
          type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_FEEDBACKS, ...results, accountBase,
        });
      },
      () => {},
    );
    return p;
  }

  const empty = {
    feedbacks: {},
    collectors: {},
    accountBase,
  };
  return Promise.resolve(empty);
}

export function fetchWinLossGlobalRankings(criteria) {
  return (dispatch) => {
    const empty = {
      status: null,
      errors: null,
      owners: [],
    };
    dispatch({
      type: DASHBOARD_FETCH_WIN_LOSS_GLOBAL_RANKINGS, ...empty, status: 'loading', errors: null,
    });
    const p = callApi('dashboard/win-loss/rankings', 'POST', criteria);
    p.then(
      results => dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_GLOBAL_RANKINGS, ...results, status: 'loaded', errors: null,
      }),
      errors => dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_GLOBAL_RANKINGS, ...empty, status: 'error', errors: errors.data || errors,
      }),
    );
    return p;
  };
}


export function fetchWinLossAllSellerFeedbacks(dispatch, ids) {
  if (ids && ids.length) {
    const uri = 'dashboard/win-loss/opportunity-seller-feedbacks';
    const p = callApi(uri, 'POST', { ids });
    p.then(
      (feedbacks) => {
        dispatch({
          type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_SELLER_FEEDBACKS, feedbacks,
        });
      },
      () => {},
    );
    return p;
  }

  const empty = {
    feedbacks: {},
  };
  return Promise.resolve(empty);
}

export function submitSellerFeedbacks(clientId, initiativeId, id, params) {
  return (dispatch) => {
    const p = callApi(`dashboard/win-loss/clients/${clientId}/programs/${initiativeId}/opportunities/${id}/seller-feedbacks`, 'POST', params);
    p.then(
      feedbacks => dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_SELLER_FEEDBACKS, feedbacks,
      }),
      () => {},
    );
    return p;
  };
}

export function appendOpportunityContactRole(opportunity, contact) {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_APPEND_OPPORTUNITY_CONTACT_ROLE, opportunity, contact,
    });  
  }
}

function fetchOpportunities(
  criteria,
  hasNoDecision,
  requestedModule = 'win-loss',
  included = ['owners', 'stageHistories', 'logHistories', 'accounts', 'lineItems'],
  accountBase = false,
  quickSearch = false,
) {
  return (dispatch) => {
    const empty = {
      status: null,
      errors: null,
      opportunities: [],
      owners: {},
      accounts: {},
      hasNoDecision,
    };
    if (!quickSearch) {
      dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES, ...empty, status: 'loading', errors: null, hasNoDecision, quickSearch,
      });  
    }

    if (quickSearch && (!criteria.q || criteria.q.length === 0)) {
      // clean the reducer
      dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES, opportunities: [], status: 'loaded', errors: null, hasNoDecision, quickSearch,
      });
      return Promise.resolve({ opportunities: [], total: 0 });
    }
    
    const { team } = criteria;

    const teamId = team && team._id ? `&teamId=${team._id}` : '';
    delete criteria.team;

    const p = new Promise((rs, rj) => {
      const pp = callApi(`dashboard/${requestedModule}/${(accountBase ? 'accounts' : 'opportunities')}/?include=${included.join(',')}${teamId}`, 'POST', criteria);
      pp.then(
        (r) => {
          delay(
            () => {
              rs(r);
            }
          , quickSearch ? 0 : 0); // delay for testing the UI when search take time to return. remove this when done.
        },
        (e) => {
          rj(e);
        }
      );
    });

    p.then(
      (results) => {
        const { opportunities } = results;
        const ids = uniq(map(opportunities, accountBase ? 'account_id' : 'opportunity_id'));
        delay(() => {
          const p1 = fetchWinLossAllFeedbacks(dispatch, ids, accountBase);
          const p2 = fetchWinLossAllSellerFeedbacks(dispatch, ids);
          Promise.all([p1, p2])
            .then(
              () => {
                dispatch({
                  type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES, opportunities: null, status: 'loaded', errors: null, hasNoDecision,
                });
              },
              () => {
                if (!quickSearch) {
                  dispatch({
                    type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES, opportunities: null, status: 'loaded', errors: null, hasNoDecision,
                  });
                }
              },
            );
        }, 500);
        dispatch({
          type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES, ...results, status: 'loading', errors: null, hasNoDecision, quickSearch,
        });
      },
      (errors) => {
        if (!quickSearch) {
          dispatch({
            type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITIES, ...empty, status: 'error', errors: errors.data || errors, hasNoDecision, quickSearch,
          });
        }
      },
    );
    return p;
  };
}

export function fetchWinLossOpportunities(criteria, hasNoDecision,
  included = ['owners', 'stageHistories', 'logHistories', 'accounts', 'lineItems'])
{
  return fetchOpportunities(criteria, hasNoDecision, 'win-loss', included, false);
}
export function fetchFeedbackOpportunities(criteria, hasNoDecision,
  included = ['accounts', 'owners', 'accountWebsite', 'contactRoles', 'accountContactCount', 'lineItems', 'accountIndustries', 'internalEmailCount'], quickSearch = false)
{
  return fetchOpportunities(criteria, hasNoDecision, 'feedback', included, false, quickSearch);
}
export function fetchLeaderboardOpportunities(criteria, hasNoDecision,
  included = ['accounts', 'owners', 'accountWebsite', 'contactRoles', 'accountContactCount', 'lineItems', 'repTypes', 'repRegions', 'products', 'accountIndustries'])
{
  return fetchOpportunities(criteria, hasNoDecision, 'leaderboard', included, false);
}
export function fetchFeedbackExperienceOpportunities(criteria, hasNoDecision,
  included = ['accounts', 'owners', 'accountWebsite', 'contactRoles', 'accountContactCount', 'lineItems', 'accountIndustries', 'internalEmailCount'], quickSearch = false)
{
  return fetchOpportunities(criteria, hasNoDecision, 'feedback', included, true, quickSearch);
}

export function fetchFeedbackExcludedOpportunities(criteria, hasNoDecision,
  included = ['accounts', 'owners', 'accountWebsite', 'contactRoles', 'accountContactCount', 'lineItems', 'repTypes', 'repRegions', 'accountIndustries', 'products'])
{ 
  return (dispatch) => {
    const empty = {
      status: null,
      errors: null,
      opportunities: [],
      stats: {}, // won/lost/nd
      hasNoDecision,
    };
    dispatch({
      type: DASHBOARD_FETCH_EXCLUDED_OPPORTUNITIES, ...empty, status: 'loading', errors: null, hasNoDecision,
    });

    const { team } = criteria;

    const teamId = team && team._id ? `&teamId=${team._id}` : '';
    delete criteria.team;

    const p = callApi(`dashboard/exclusions/opportunities/?include=${included.join(',')}${teamId}`, 'POST', criteria);
    p.then(
      (results) => {
        return dispatch({
          type: DASHBOARD_FETCH_EXCLUDED_OPPORTUNITIES, ...results, status: 'loaded', errors: null, hasNoDecision,
        });
      },
      errors => dispatch({
        type: DASHBOARD_FETCH_EXCLUDED_OPPORTUNITIES, ...empty, status: 'error', errors: errors.data || errors, hasNoDecision,
      }),
    );
    return p;
  };
}

export function fetchFeedbackExcludedContacts(ids) {
  return (dispatch) => {
    const empty = {
      status: null,
      errors: null,
      contacts: [],
    };
    dispatch({
      type: DASHBOARD_FETCH_EXCLUDED_CONTACTS, ...empty, status: 'loading', errors: null,
    });

    const p = callApi('dashboard/exclusions/opportunities/contacts', 'POST', { ids });
    p.then(
      (contacts) => {
        return dispatch({
          type: DASHBOARD_FETCH_EXCLUDED_CONTACTS, contacts, status: 'loaded', errors: null,
        });
      },
      errors => dispatch({
        type: DASHBOARD_FETCH_EXCLUDED_CONTACTS, ...empty, status: 'error', errors: errors.data || errors,
      }),
    );
    return p;
  };
}


export function fetchFeedbackProgressContacts(automationId, automationSource, ids) {
  return (dispatch) => {
    if (!ids || ids.length === 0) {
      return dispatch({
        type: DASHBOARD_FETCH_PROGRESS_CONTACTS, contacts: [], status: 'loaded', errors: null, automationSource,
      });
    }
    const empty = {
      status: null,
      errors: null,
      contacts: [],
    };
    dispatch({
      type: DASHBOARD_FETCH_PROGRESS_CONTACTS, ...empty, status: 'loading', errors: null, automationSource,
    });

    const p = callApi(`dashboard/progress/${automationId}/contacts`, 'POST', { ids });
    p.then(
      (contacts) => {
        return dispatch({
          type: DASHBOARD_FETCH_PROGRESS_CONTACTS, contacts, status: 'loaded', errors: null, automationSource,
        });
      },
      errors => dispatch({
        type: DASHBOARD_FETCH_PROGRESS_CONTACTS, ...empty, status: 'error', errors: errors.data || errors, automationSource,
      }),
    );
    return p;
  };
}


export function requestEditWinLossOpportunityFeedbacks(opportunity, contact) {
  return dispatch => dispatch({
    type: DASHBOARD_REQUEST_EDIT_WIN_LOSS_OPPORTUNITY_FEEDBACKS, opportunity, contact,
  });
}
export function requestEditWinLossAccountFeedbacks(account) {
  return dispatch => dispatch({
    type: DASHBOARD_REQUEST_EDIT_WIN_LOSS_ACCOUNT_FEEDBACKS, account,
  });
}

// fetch detail feedback
export function fetchWinLossOpportunityFeedback(id) {
  return (dispatch) => {
    const p = callApi(`dashboard/win-loss/opportunities/${id}/feedbacks`, 'GET');
    p.then(
      results => dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_FEEDBACK, ...results, id,
      }),
      () => {},
    );
    return p;
  };
}
export function fetchWinLossAccountFeedback(id) {
  return (dispatch) => {
    const p = callApi(`dashboard/win-loss/accounts/${id}/feedbacks`, 'GET');
    p.then(
      results => dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_FEEDBACK, ...results, id,
      }),
      () => {},
    );
    return p;
  };
}

export function fetchWinLossOpportunityContacts(opportunityId) {
  return (dispatch) => {
    const p = callApi(`dashboard/opportunities/${opportunityId}/contacts`, 'GET');
    p.then(
      results => dispatch({
        type: DASHBOARD_REQUEST_LOAD_WIN_LOSS_OPPORTUNITY_CONTACTS, ...results, opportunityId,
      }),
      () => {},
    );
    return p;
  };
}

export function fetchOpportunityRequestStatus(stateIds, requestedIds, source = 'opportunity', isApex = false) {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_FETCH_OPPORTUNITY_FEEDBACK_REQUEST_STATUS,
      feedbackRequestables: stateIds.reduce((acc, id) => {
        acc[id] = { loading: true, error: null, feedbackRequestable: null };
        return acc;
      }, {}),
    });


    const p = callApi(`dashboard/opportunities/request-status${isApex ? '?apex=true' : ''}`, 'POST', { opportunityIds: requestedIds, source });
    p.then(
      (response) => {
        const data = stateIds.reduce((acc, id) => {
          acc[id] = {
            loading: false,
            error: response[id]?.error,
            feedbackRequestable: !!response[id]?.feedbackRequestable || response.feedback_requestable,
          };
          if (response[id]?.hideApexExcludeButton === true) {
            acc[id].hideApexExcludeButton = true;
          }
          return acc;
        }, {});
        dispatch({
          type: DASHBOARD_FETCH_OPPORTUNITY_FEEDBACK_REQUEST_STATUS,
          feedbackRequestables: data,
        });
      },
      (error) => {
        const errorStatus = stateIds.reduce((acc, id) => {
          acc[id] = { loading: false, error, feedbackRequestable: false };
          return acc;
        }, {});
        dispatch({
          type: DASHBOARD_FETCH_OPPORTUNITY_FEEDBACK_REQUEST_STATUS,
          feedbackRequestables: errorStatus,
        });
      },
    );

    return p;
  };
}

export function fetchWinLossAccountContacts(accountId) {
  return (dispatch) => {
    const p = callApi(`dashboard/accounts/${accountId}/contacts`, 'GET');
    p.then(
      results => dispatch({
        type: DASHBOARD_REQUEST_LOAD_WIN_LOSS_ACCOUNT_CONTACTS, ...results, accountId,
      }),
      () => {},
    );
    return p;
  };
}


export function fetchInsights(opportunityId, insightId, silent = false) {
  return (dispatch) => {
    if (!silent) {
      dispatch({
        type: DASHBOARD_REQUEST_LOAD_OPPORTUNITY_INSIGHTS, status: 'loading', errors: null, data: null, show: true,
      });
    }
    const p = callApi(`dashboard/win-loss/opportunities/${opportunityId}/insights/${insightId}`, 'GET');
    p.then(
      ({ insight }) => {
        if (!silent) {
          return dispatch({
            type: DASHBOARD_REQUEST_LOAD_OPPORTUNITY_INSIGHTS,
            data: insight,
            opportunityId,
            insightId,
            status: 'loaded',
            errors: null,
            show: true,
          });
        }
        return insight;
      },
      (errors) => {
        if (!silent) {
          return dispatch({
            type: DASHBOARD_REQUEST_LOAD_OPPORTUNITY_INSIGHTS,
            data: null,
            opportunityId,
            insightId,
            status: 'error',
            errors,
            show: true,
          });
        }
        return errors;
      },
    );
    return p;
  };
}

export function fetchAccountInsights(accountId, insightId, silent = false) {
  return (dispatch) => {
    if (!silent) {
      dispatch({
        type: DASHBOARD_REQUEST_LOAD_ACCOUNT_INSIGHTS, status: 'loading', errors: null, data: null, show: true,
      });
    }
    const p = callApi(`dashboard/win-loss/accounts/${accountId}/insights/${insightId}`, 'GET');
    p.then(
      ({ insight }) => {
        if (!silent) {
          return dispatch({
            type: DASHBOARD_REQUEST_LOAD_ACCOUNT_INSIGHTS,
            data: insight,
            accountId,
            insightId,
            status: 'loaded',
            errors: null,
            show: true,
          });
        }
        return insight;
      },
      (errors) => {
        if (!silent) {
          return dispatch({
            type: DASHBOARD_REQUEST_LOAD_ACCOUNT_INSIGHTS,
            data: null,
            accountId,
            insightId,
            status: 'error',
            errors,
            show: true,
          });
        }
        return errors;
      },
    );
    return p;
  };
}



export function hideInsights() {
  return (dispatch) => {
    return dispatch({
      type: DASHBOARD_REQUEST_LOAD_OPPORTUNITY_INSIGHTS, status: null, errors: null, data: null, show: false,
    });
  };
}

// fetch detail surveys
export function fetchWinLossOpportunitySurveys(id) {
  return (dispatch) => {
    const p = callApi(`dashboard/win-loss/opportunities/${id}/surveys`, 'GET');
    p.then(
      (results) => {
        return dispatch({
          type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_SURVEYS, ...results, id,
        });
      },
    );
    return p;
  };
}

export function fetchWinLossAccountSurveys(id) {
  return (dispatch) => {
    const p = callApi(`dashboard/win-loss/accounts/${id}/surveys`, 'GET');
    p.then(
      results => dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_SURVEYS, ...results, id,
      }),
      () => {},
    );
    return p;
  };
}

export function fetchWinLossInternalEmailStatus(id, isAccount = false) {
  return (dispatch) => {
    const p = callApi(`dashboard/win-loss/${isAccount ? 'accounts' : 'opportunities'}/${id}/internal-emails`, 'GET');
    p.then(
      (internalEmails) => dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_INTERNAL_EMAILS, internalEmails, id, isAccount,
      }),
      () => {},
    );
    return p;
  };
}

export function submitContactsToSurveyCollector(program, collector, products, fromEmail, object, contacts, collectorType, isAccount = false, isOverride = false, automationId = null, forceSenderEmailFrom = false, debug = false) {
  return (dispatch) => {
    const id = isAccount ? object.account_id : object.opportunity_id;
    const params = {
      [isAccount ? 'account_id' : 'opportunity_id']: id,
      ...(isAccount ? {
        won_opportunities: object.won_opportunities || [],
      } : {}),
      product_ids: map(products, 'id'),
      from_email: fromEmail, // can be null
      collector_type: collectorType,
      contacts: contacts.map(contact => ({
        contact_id: contact.contact_id,
        first_name: contact.first_name,
        last_name: contact.last_name,
        title: contact.title,
        email: contact.email,
        phone: contact.phone,
        phone_ext: contact.phone_ext,
        mobile_phone: contact.mobile_phone,
        notes: contact.notes,
        language: contact.language,
        role: contact.role ? contact.role.role : null,
      })),
      is_account: isAccount,
      is_override: isOverride,
      automation_id: automationId,
      force_send_email_from: forceSenderEmailFrom,
    };
    const collectorId = collector.collector_id;

    return new Promise((resolve, reject) => {
      seq(
        (callback) => {
          const p = callApi(`dashboard/win-loss/programs/${program.id}/collectors/${collectorId}${debug ? '?debug=true' : ''}`, 'POST', params);
          p.then(
            ({
              results, stats, feedbacks, surveys,
            }) => {
              callback(null, results, stats, feedbacks, surveys);
            },
            (errors) => {
              callback(errors);
            },
          );
        },
        (results, stats, feedbacks, surveys, callback) => {
          dispatch({
            type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_FEEDBACKS, ...stats, accountBase: isAccount,
          });
          const { collectors } = stats;
          const total = reduce(collectors, (i, c) => i + (c.total || 0), 0);
          dispatch({ type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_REQUESTED_FEEDBACK, total, id });
          dispatch({ type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_FEEDBACK, feedbacks, id });
          dispatch({ type: DASHBOARD_FETCH_WIN_LOSS_OPPORTUNITY_SURVEYS, surveys, id });
          callback(null, results, feedbacks, surveys);
        },
        (results, feedbacks, surveys, callback) => {
          callback(null, { contacts: results, feedbacks, surveys });
        },
      )((errors, results) => {
        if (errors) {
          reject(errors);
        } else {
          resolve(results);
        }
      });
    });
  };
}


export function requestShowSurveyEmail(data) {
  return dispatch => dispatch({
    type: DASHBOARD_REQUEST_SHOW_WIN_LOSS_SURVEY_EMAIL, data,
  });
}

export function winLossCancelSurveys(collectorId, id, contactId, isAccount = false, params = {}, c) {
  return (dispatch) => {
    const resource = isAccount ? 'accounts' : 'opportunities';
    const p = callApi(`dashboard/win-loss/collectors/${collectorId}/${resource}/${id}/contacts/${contactId}/cancel`, 'PUT', params);
    p.then(
      contact => dispatch({
        type: DASHBOARD_REQUEST_CANCEL_WIN_LOSS_SURVEY, collectorId, id, contactId, contact,
      }),
      () => {},
    );
    return p;
  };
}


export function winLossDeleteSurveys(collectorId, id, contactId, isAccount = false) {
  return (dispatch) => {
    const resource = isAccount ? 'accounts' : 'opportunities';
    const p = callApi(`dashboard/win-loss/collectors/${collectorId}/${resource}/${id}/contacts/${contactId}`, 'DELETE');
    p.then(
      () => {
        fetchWinLossAllFeedbacks(dispatch, [id], isAccount);
        return dispatch({
          type: DASHBOARD_REQUEST_DELETE_WIN_LOSS_SURVEY, collectorId, id, contactId,
        });
      },
      () => {},
    );
    return p;
  };
}

export function winLossSendNextEmail(collectorId, collectorTZ, id, contactId, params, isAccount = false) {
  return (dispatch) => {
    const resource = isAccount ? 'accounts' : 'opportunities';
    const p = callApi(`dashboard/win-loss/collectors/${collectorId}/${resource}/${id}/contacts/${contactId}`, 'POST', params);
    p.then(
      result => dispatch({
        type: DASHBOARD_REQUEST_WIN_LOSS_SEND_NEXT_EMAIL,
        collectorId,
        id,
        contactId,
        result,
        collectorTZ,
      }),
      () => {},
    );
    return p;
  };
}


export function winLossScheduleNextEmail(collectorId, collectorTZ, id, contactId, stepId, params, isAccount = false) {
  const resource = isAccount ? 'accounts' : 'opportunities';
  const uri = stepId ?
    `dashboard/win-loss/collectors/${collectorId}/${resource}/${id}/contacts/${contactId}/steps/${stepId}` :
    `dashboard/win-loss/collectors/${collectorId}/${resource}/${id}/contacts/${contactId}`;
  return (dispatch) => {
    const p = callApi(uri, 'PUT', params);
    p.then(
      contact => dispatch({
        type: DASHBOARD_REQUEST_RESCHEDULE_WIN_LOSS_SURVEY,
        id,
        collectorId,
        contactId,
        stepId,
        contact,
      }),
      () => {},
    );
    return p;
  };
}

export function winLossPreviewNextEmail(collectorId, id, contactId, stepId, params, isAccount = false) {
  const resource = isAccount ? 'accounts' : 'opportunities';
  const uri = `dashboard/win-loss/collectors/${collectorId}/${resource}/${id}/contacts/${contactId}/steps/${stepId}/preview`;
  return () => {
    const p = callApi(uri, 'POST', params);
    return p;
  };
}

export function winLossRequestTogglePauseSurvey(collectorId, id, contactId, pause = false, isAccount = false) {
  return (dispatch) => {
    const resource = isAccount ? 'accounts' : 'opportunities';
    const uri = `dashboard/win-loss/collectors/${collectorId}/${resource}/${id}/contacts/${contactId}/${(pause ? 'pause' : 'resume')}`;
    const p = callApi(uri, 'PUT');
    p.then(
      (contact) => {
        dispatch({
          type: DASHBOARD_REQUEST_TOGGLE_PAUSE_WIN_LOSS_SURVEY, collectorId, id, contactId, contact,
        });
      },
      () => {},
    );
    return p;
  };
}

export function winLossRequestReschedule(collectorId, id, contactId, stepId, date, isAccount = false) {
  return (dispatch) => {
    const resource = isAccount ? 'accounts' : 'opportunities';
    const uri = stepId ?
      `dashboard/win-loss/collectors/${collectorId}/${resource}/${id}/contacts/${contactId}/steps/${stepId}/reschedule` :
      `dashboard/win-loss/collectors/${collectorId}/${resource}/${id}/contacts/${contactId}/reschedule`;
    const p = callApi(uri, 'PUT', { date });
    p.then(
      (contact) => {
        dispatch({
          type: DASHBOARD_REQUEST_RESCHEDULE_WIN_LOSS_SURVEY,
          id,
          collectorId,
          contactId,
          stepId,
          contact,
        });
      },
      () => {},
    );
    return p;
  };
}


export function winLossFetchCollectorSummary(collectorId, id, isAccount = false) {
  return (dispatch) => {
    const uri = isAccount ? `dashboard/win-loss/collectors/${collectorId}/accounts/${id}/summary` : `dashboard/win-loss/collectors/${collectorId}/opportunities/${id}/summary`;
    const p = callApi(uri, 'GET');
    p.then(
      (steps) => {
        return dispatch({
          type: DASHBOARD_FETCH_COLLECTOR_SUMMARY,
          collectorId,
          id,
          steps,
        });
      },
      () => {},
    );
    return p;
  };
}


export function winLossExcludeOpportunity(opportunityId, params) {
  return (dispatch) => {
    const p = callApi(`dashboard/win-loss/opportunities/${opportunityId}/exclude`, 'POST', params);
    p.then(
      result => dispatch({
        type: DASHBOARD_WIN_LOSS_EXCLUDE_OPPORTUNITY,
        result,
      }),
      () => {},
    );
    return p;
  };
}

export function winLossExcludeAccount(accountId, params) {
  return (dispatch) => {
    const p = callApi(`dashboard/win-loss/accounts/${accountId}/exclude`, 'POST', params);
    p.then(
      result => dispatch({
        type: DASHBOARD_WIN_LOSS_EXCLUDE_ACCOUNT,
        result,
      }),
      () => {},
    );
    return p;
  };
}

export function winLossIncludeOpportunity(opportunityId) {
  return (dispatch) => {
    const p = callApi(`dashboard/win-loss/opportunities/${opportunityId}/exclude`, 'DELETE');
    p.then(
      () => dispatch({
        type: DASHBOARD_WIN_LOSS_INCLUDE_OPPORTUNITY,
        opportunityId,
      }),
      () => {},
    );
    return p;
  };
}

export function winLossIncludeAccount(accountId) {
  return (dispatch) => {
    const p = callApi(`dashboard/win-loss/accounts/${accountId}/exclude`, 'DELETE');
    p.then(
      () => dispatch({
        type: DASHBOARD_WIN_LOSS_INCLUDE_ACCOUNT,
        accountId,
      }),
      () => {},
    );
    return p;
  };
}


export function fetchAccountResults(id) {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_FETCH_WIN_LOSS_ACCOUNT_RESULTS, status: 'loading', error: null, results: null, id,
    });
    const p = callApi(`dashboard/win-loss/accounts/${id}/results`, 'GET');
    p.then(
      results => dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_ACCOUNT_RESULTS, status: 'loaded', error: null, results, id,
      }),
      (error) => {
        dispatch({
          type: DASHBOARD_FETCH_WIN_LOSS_ACCOUNT_RESULTS, status: 'error', results: null, error, id,
        });
      },
    );
    return p;
  };
}

export function fetchAccountJobs(id) {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_FETCH_WIN_LOSS_ACCOUNT_JOBS, status: 'loading', error: null, jobs: null, id,
    });
    const p = callApi(`accounts/${id}/jobs`, 'GET');
    p.then(
      ({ jobs }) => dispatch({
        type: DASHBOARD_FETCH_WIN_LOSS_ACCOUNT_JOBS, status: 'loaded', error: null, jobs, id,
      }),
      (error) => {
        dispatch({
          type: DASHBOARD_FETCH_WIN_LOSS_ACCOUNT_JOBS, status: 'error', jobs: null, error, id,
        });
      },
    );
    return p;
  };
}

export function addAccountJob(id, params) {
  return (dispatch) => {
    const p = callApi(`accounts/${id}/jobs`, 'POST', params);
    p.then(
      job => dispatch({
        type: DASHBOARD_ADD_WIN_LOSS_ACCOUNT_JOB, job, id,
      }),
      () => {},
    );
    return p;
  };
}
export function updateAccountJob(id, jobId, params) {
  return (dispatch) => {
    const p = callApi(`accounts/${id}/jobs/${jobId}`, 'PUT', params);
    p.then(
      job => dispatch({
        type: DASHBOARD_ADD_WIN_LOSS_ACCOUNT_JOB, job, id,
      }),
      () => {},
    );
    return p;
  };
}

export function deleteAccountJob(id, jobId) {
  return (dispatch) => {
    const p = callApi(`accounts/${id}/jobs/${jobId}`, 'DELETE');
    p.then(
      () => dispatch({
        type: DASHBOARD_DELETE_WIN_LOSS_ACCOUNT_JOB, jobId, id,
      }),
      () => {},
    );
    return p;
  };
}


export function updateAccountStatus(id, status) {
  return (dispatch) => {
    const p = callApi(`accounts/${id}/customer-status`, 'PUT', { customer_status: status });
    p.then(
      (account) => {
        return dispatch({
          type: DASHBOARD_UPDATE_WIN_LOSS_ACCOUNT_STATUS, account,
        });
      },
      () => {},
    );
    return p;
  };
}


export function fetchCollectorStats(collectorId, ids, isAccount = false) {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_FETCH_COLLECTOR_STATS, collectorId, isAccount, data: [], status: 'loading', errors: null,
    });
    const p = callApi(`dashboard/win-loss/collectors/${collectorId}/${(isAccount ? 'accounts' : 'opportunities')}/stats`, 'POST', { ids });
    p.then(
      (results) => {
        // const steps = results.steps || results;
        dispatch({
          type: DASHBOARD_FETCH_COLLECTOR_STATS,
          collectorId,
          isAccount,
          data: results,
          status: 'loaded',
          errors: null,
        });
      },
      errors => dispatch({
        type: DASHBOARD_FETCH_COLLECTOR_STATS,
        collectorId,
        isAccount,
        data: {},
        status: 'errors',
        errors,
      }),
    );
    return p;
  };
}


export function updateSenderEmail(collectorId, id, contactId, email, isAccount = false) {
  return (dispatch) => {
    const uri = `dashboard/win-loss/collectors/${collectorId}/${(isAccount ? 'accounts' : 'opportunities')}/${id}/contacts/${contactId}/sender`;
    const p = callApi(uri, 'PUT', { send_email_from: email });
    p.then((contact) => {
      dispatch({
        type: DASHBOARD_REQUEST_CHANGE_CONTACT_SENDER,
        id,
        collectorId,
        contactId,
        contact,
      });
    });
    return p;
  };
}

export function fetchCommnunicationRecipient(id, isAccount = false) {
  return () => {
    const uri = `dashboard/win-loss/${(isAccount ? 'accounts' : 'opportunities')}/${id}/communications-recipient`;
    const p = callApi(uri, 'GET');
    return p;
  };
}

export function updateCommnunicationRecipient(id, communicationsRecipientId, isAccount = false) {
  return () => {
    const uri = `dashboard/win-loss/${(isAccount ? 'accounts' : 'opportunities')}/${id}/communications-recipient`;
    const p = callApi(uri, 'PUT', { communicationsRecipientId });
    return p;
  };
}

export function recalculateAccountSizeStats(minAccountSize, maxAccountSize) {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_REQUEST_CHANGE_ACCOUNT_SIZE,
      minAccountSize,
      maxAccountSize,
    });
  };
}

export function updateSenderLanguage(collectorId, id, contactId, language, isAccount = false) {
  return (dispatch) => {
    const uri = `dashboard/win-loss/collectors/${collectorId}/${(isAccount ? 'accounts' : 'opportunities')}/${id}/contacts/${contactId}/language`;
    const p = callApi(uri, 'PUT', { language: lowerCase(language).split(' ').join('-') });
    p.then(() => {
      dispatch({
        type: DASHBOARD_REQUEST_CHANGE_CONTACT_SENDER,
        id,
        collectorId,
        contactId,
        contact: {
          language,
        },
      });
    });
    return p;
  };
}

export function loadCompetitors(clientId, initiativeId, productIds = []) {
  return () => {
    const uri = `truvoice/clients/${clientId}/initiatives/${initiativeId}/competitors`;
    const p = callApi(uri, 'GET', { product_ids: productIds.join(',') });
    return p;
  };
}

export function loadPricePositions(clientId, initiativeId, productIds = []) {
  return () => {
    const uri = `truvoice/clients/${clientId}/initiatives/${initiativeId}/price-positions`;
    const p = callApi(uri, 'GET', { product_ids: productIds.join(',') });
    return p;
  };
}

export function loadAttributes(clientId, initiativeId, productIds = []) {
  return () => {
    const uri = `truvoice/clients/${clientId}/initiatives/${initiativeId}/attributes`;
    const p = callApi(uri, 'GET', { product_ids: productIds.join(',') });
    return p;
  };
}

export function loadCriateria(clientId, initiativeId, productIds = []) {
  return () => {
    const uri = `truvoice/clients/${clientId}/initiatives/${initiativeId}/criteria`;
    const p = callApi(uri, 'GET', { product_ids: productIds.join(',') });
    return p;
  };
}

export function loadSettings(automationId = null, isAccount = false) {
  return (dispatch) => {
    const uri = `dashboard/win-loss/feedback-request-settings`;
    const p = callApi(uri, 'GET', automationId ? { automationId, isAccount } : { isAccount });
    p.then((settings) => {
      dispatch({
        type: DASHBOARD_FEEDBACK_REQUEST_SETTINGS,
        settings,
      });
    });
    return p;
  };
}

export function getReminderEmailStatus(id, isAccount = false) {
  return () => {
    const uri = `dashboard/win-loss/${(isAccount ? 'accounts' : 'opportunities')}/${id}/reminder-email-status`;
    const p = callApi(uri, 'GET');
    return p;
  };
}

export function updateReminderEmailStatus(id, disabled, isAccount = false) {
  return () => {
    const uri = `dashboard/win-loss/${(isAccount ? 'accounts' : 'opportunities')}/${id}/reminder-email-status`;
    const p = callApi(uri, 'PUT', { disabled });
    return p;
  };
}

function decodeChunk(dataChunk, rawResponse) {
  const dataChunks = compact(dataChunk.split(/(\]\s*\[)/).map((d) => {
    const s = trim(trim(d, '[]'));
    if (s.length > 0) {
      return s;
    }
    return null;
  })).join(',');

  try {
    const jsonData = JSON.parse(`[${dataChunks}]`);
    return jsonData;
  } catch (e) {
    // console.log('>>>>>');
    // console.log('>>> decode error', dataChunk);
    // console.log()
    // console.log(e);
    return null;
  }
}

export function checkQualified(searchId, automationId, ids, isAccount = false, revenueMin = null, revenueMax = null, dateAnchor = null) {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_CHECK_QUALIFIED_CHUNK,
      searchId,
      isAccount,
      chunk: null,
      isReset: true, // reset
      revenueMin,
      revenueMax,
    });

    let lastDataChunk = '';

    const onDownloadProgress = (progressEvent) => {
      // dataChunk contains the data that have been obtained so far (the whole data so far).. 
      // So here we do whatever we want with this partial data.. 
      const evt = progressEvent.event || progressEvent;
      const target = evt.currentTarget || evt.target;

      const dataChunk = trim((target.response || '').substring(lastDataChunk.length));

      if (dataChunk.length > 0) {
        const jsonData = decodeChunk(dataChunk, target.response);

        if (jsonData) {
          lastDataChunk = target.response;
          dispatch({
            type: DASHBOARD_CHECK_QUALIFIED_CHUNK,
            isAccount,
            chunk: jsonData,
            searchId,
            revenueMin,
            revenueMax,
          });
        }
      }
    };

    const params = { ids };
    if (dateAnchor) {
      params.date = dateAnchor.format('YYYY-MM-DD');
    }
    const response = callApi(`dashboard/win-loss/automations/${automationId}/check-qualify`, 'POST', params, true, { responseType: 'stream', onDownloadProgress });
    
    response.then(
      (res) => {
        dispatch({
          type: DASHBOARD_CHECK_QUALIFIED_CHUNK,
          isAccount,
          // chunk: decodeChunk(res) || [],
          chunk: decodeChunk(JSON.stringify(res, null, 0)) || [],
          searchId,
          revenueMin,
          revenueMax,
        });
      },
      (error) => {
        dispatch({
          type: DASHBOARD_CHECK_QUALIFIED_CHUNK,
          isAccount,
          searchId,
          error: true,
        });
      },
    );
    
    return response;
  };
}